// Source of truth for app configuration at runtime.
// Configuration is selected from location.hostname via host-config.ts,
// so a single production build works on every App Service slot.
// See host-config.ts for the per-slot table.

import { resolveAppConfig } from './host-config';

const hostname =
    typeof window !== 'undefined' && window.location
        ? window.location.hostname
        : null;

export const environment = resolveAppConfig(hostname);

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
